import axios from 'axios'
import endpoints from '@/api/endpoints'


export default {
  async createLawnProject (obj) {
    return axios.post(endpoints.lawnProjects, obj).then((response) => {
      return response.data
    })
  },
  async updateLawnProject (obj) {
    return axios.patch(endpoints.lawnProjects + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  async getLawnProjects () {
    return axios.get(endpoints.lawnProjects).then((response) => {
      return response.data
    })
  }
}
